export const validatePhoneNumber = (phoneNumber: string) => {
  return !phoneNumber || phoneNumber.match(/\d/g)?.length === 11 || phoneNumber.match(/\d/g)?.length === 1 || phoneNumber.match(/\d/g)?.length === 0;
};
